var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("modifyPkgSpecification"),
          value: _vm.value,
          rightMethod: _vm.onSubmitted,
          leftMethod: function() {
            return _vm.$emit("input", false)
          },
          rightButtonDisabled: !_vm.isEmpty,
          small: "",
          hasAlert: ""
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { attrs: { md5: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "required_field",
                          attrs: {
                            label: _vm.$t("packageName"),
                            rules: [_vm.isDuplicateName]
                          },
                          model: {
                            value: _vm.pkgName,
                            callback: function($$v) {
                              _vm.pkgName =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "pkgName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md4: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              disabled: !Boolean(_vm.pkgName)
                            },
                            on: {
                              click: function($event) {
                                return _vm.addPkg(_vm.pkgName)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { dark: "" } }, [
                              _vm._v("add")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-layout",
                          { attrs: { "justify-space-between": "" } },
                          [
                            _c(
                              "v-flex",
                              { attrs: { md7: "" } },
                              [
                                _c("vite-autocomplete", {
                                  attrs: {
                                    "hide-details": "",
                                    items: _vm.order.packagingSpecs,
                                    label: _vm.$t("SelectPackaging"),
                                    "item-text": "packageName",
                                    "return-object": ""
                                  },
                                  model: {
                                    value: _vm.order.packaging,
                                    callback: function($$v) {
                                      _vm.$set(_vm.order, "packaging", $$v)
                                    },
                                    expression: "order.packaging"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              [
                                _vm.order.packagingSpecs &&
                                _vm.order.packagingSpecs.length
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { dark: "", color: "primary" },
                                        on: {
                                          click: function($event) {
                                            return _vm.deletePkg(
                                              _vm.order.packaging.packageName
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-layout",
                          { attrs: { "justify-space-between": "" } },
                          [
                            _c(
                              "v-flex",
                              { attrs: { md7: "" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "hide-details": "",
                                    rules: [
                                      _vm.fieldIsRequired("weight"),
                                      _vm.fieldIsOverZero("weight"),
                                      _vm.isMeasurementMetric
                                        ? function() {
                                            return true
                                          }
                                        : _vm.fieldIsPkgWeight(
                                            _vm.order["isOz"]
                                          )
                                    ],
                                    label: _vm.isMeasurementMetric
                                      ? _vm.$t("weight") + "(kg)"
                                      : _vm.$t("weight") +
                                        "(" +
                                        (_vm.order["isOz"]
                                          ? _vm.$t("clickSwitch", {
                                              click: "Oz",
                                              change: "Lbs"
                                            })
                                          : _vm.$t("clickSwitch", {
                                              click: "Lbs",
                                              change: "Oz"
                                            })) +
                                        ")"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.weightLbChange(_vm.order)
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "append",
                                      fn: function() {
                                        return [
                                          !_vm.isMeasurementMetric
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.order["isOz"] = !_vm
                                                        .order["isOz"]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.order["isOz"]
                                                        ? "Oz"
                                                        : "Lbs"
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ]),
                                  model: {
                                    value: _vm.order.packaging.weight,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.order.packaging,
                                        "weight",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "order.packaging.weight"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { md4: "" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("packageQty"),
                                    hint: _vm.$t("packageQty"),
                                    "hide-details": "",
                                    rules: [_vm.fieldIsInteger("packageQty")]
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.packageQtyChange(_vm.order)
                                    }
                                  },
                                  model: {
                                    value: _vm.order.packaging.packageQuantity,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.order.packaging,
                                        "packageQuantity",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "order.packaging.packageQuantity"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "align-center": "" } },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "mr-3", attrs: { xs4: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "table-item",
                          attrs: {
                            "hide-details": "",
                            label: _vm.$t("L"),
                            suffix: _vm.sizeSuffix,
                            rules: [
                              _vm.fieldIsRequired("length"),
                              _vm.fieldIsOverZero("length")
                            ]
                          },
                          model: {
                            value: _vm.order.packaging.length,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.order.packaging,
                                "length",
                                _vm._n($$v)
                              )
                            },
                            expression: "order.packaging.length"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { staticClass: "mr-3", attrs: { xs4: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "table-item",
                          attrs: {
                            "hide-details": "",
                            label: _vm.$t("W"),
                            suffix: _vm.sizeSuffix,
                            rules: [
                              _vm.fieldIsRequired("width"),
                              _vm.fieldIsOverZero("width")
                            ]
                          },
                          model: {
                            value: _vm.order.packaging.width,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.order.packaging,
                                "width",
                                _vm._n($$v)
                              )
                            },
                            expression: "order.packaging.width"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs4: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "table-item",
                          attrs: {
                            "hide-details": "",
                            suffix: _vm.sizeSuffix,
                            label: _vm.$t("H"),
                            rules: [
                              _vm.fieldIsRequired("height"),
                              _vm.fieldIsOverZero("height")
                            ]
                          },
                          model: {
                            value: _vm.order.packaging.height,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.order.packaging,
                                "height",
                                _vm._n($$v)
                              )
                            },
                            expression: "order.packaging.height"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "align-center": "" } },
                  [
                    _c("v-data-table", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        headers: _vm.headers,
                        "hide-actions": "",
                        items: _vm.packages
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("package")) +
                                    " " +
                                    _vm._s(props.index + 1)
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.order.packaging.skus &&
                                  _vm.order.packaging.skus[props.index]
                                    ? _vm._l(
                                        Object.keys(
                                          _vm.order.packaging.skus[props.index]
                                        ),
                                        function(key, index) {
                                          return _c(
                                            "v-chip",
                                            { key: index },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(key) +
                                                  " (" +
                                                  _vm._s(
                                                    _vm.order.packaging.skus[
                                                      props.index
                                                    ][key]
                                                  ) +
                                                  ")\n                  "
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer"
                                                  },
                                                  attrs: { size: "18" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeSku(
                                                        props.index,
                                                        key
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("close")]
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { flat: "", icon: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showAddSkuPopup(
                                            props.index
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("add")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("addSku"),
          rightMethod: _vm.addSku,
          rightButtonText: _vm.$t("add"),
          small: "",
          hasAlert: ""
        },
        on: {
          popupClose: function($event) {
            _vm.addSkuPopup.show = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  { attrs: { "justify-space-between": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.skus,
                            "item-text": "text",
                            rules: [_vm.fieldIsRequired("sku")],
                            label: _vm.$t("sku")
                          },
                          model: {
                            value: _vm.addSkuPopup.sku,
                            callback: function($$v) {
                              _vm.$set(_vm.addSkuPopup, "sku", $$v)
                            },
                            expression: "addSkuPopup.sku"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md4: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "required_field",
                          attrs: {
                            label: _vm.$t("quantity"),
                            rules: [
                              _vm.fieldIsNumber("quantity"),
                              _vm.fieldIsRequired("quantity")
                            ]
                          },
                          model: {
                            value: _vm.addSkuPopup.quantity,
                            callback: function($$v) {
                              _vm.$set(_vm.addSkuPopup, "quantity", _vm._n($$v))
                            },
                            expression: "addSkuPopup.quantity"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.addSkuPopup.show,
          callback: function($$v) {
            _vm.$set(_vm.addSkuPopup, "show", $$v)
          },
          expression: "addSkuPopup.show"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f5d043b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5d043b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModifyPkgSpecificationPopup.vue
// module id = null
// module chunks = 